import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './widget-card.module.scss'

export const WidgetCard = ({
  children,
  onClick,
  size = 'small',
  className,
  overflow = true,
  style,
}) => {
  const handleClick = useCallback(() => {
    onClick?.()
  }, [onClick])

  const handleKeyDown = useCallback(
    e => {
      if (onClick && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault()
        onClick()
      }
    },
    [onClick],
  )

  const cardClass = useMemo(
    () =>
      classNames(styles.card, styles[size], className, {
        [styles.overflow]: !overflow,
      }),
    [size, className, overflow],
  )

  const isInteractive = Boolean(onClick)

  return (
    <div
      className={cardClass}
      onClick={isInteractive ? handleClick : undefined}
      onKeyDown={isInteractive ? handleKeyDown : undefined}
      role={isInteractive ? 'button' : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      aria-pressed={isInteractive ? false : undefined}
      style={style}
    >
      {children}
    </div>
  )
}

WidgetCard.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'large']),
  className: PropTypes.string,
  overflow: PropTypes.bool,
  style: PropTypes.object,
}
